
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Combined Analytics tracking (Google Analytics + Meta Pixel)
const sendToAnalytics = (path: string) => {
  // Send to Google Analytics
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-YZLP0SDEFD', {
      page_path: path
    });
  }
  
  // Send to Meta Pixel
  if (typeof window.fbq !== 'undefined') {
    window.fbq('track', 'PageView');
  }
};

// Custom event for the first render
document.addEventListener('DOMContentLoaded', () => {
  // Initial page view
  sendToAnalytics(window.location.pathname);
});

createRoot(document.getElementById("root")!).render(<App />);
